import React, { useEffect, useState } from 'react';
import { Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import CommentForm from './CommentForm';

import * as chanceApi from '../../../lib/api/chance';
import SingleComment from './SingleComment';
import { useDispatch, useSelector } from 'react-redux';
import { listComments } from '../../../modules/techModule/projectComments';


const CommentList = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { commentList, project } = useSelector(({ techModule }) => ({
    project: techModule.project.project,
    commentList: techModule.projectComments.comments,
  }));

  useEffect(() => {
    dispatch(listComments(project.prjUuid));

    // return () => {
    //   dispatch(unloadComments());
    // };
  }, [project.prjUuid, dispatch]);

  const [commentValue, setCommentValue] = useState('');

  const handleEditorChange = (data) => {
    setCommentValue(data);
  };

  const onSubmit = async (event) => {
    event.preventDefault(); //refresh 막음
    const dataToSubmit = {
      prjUuid: project.prjUuid,
      brdTxt: commentValue,
    };

   // console.log(JSON.stringify(dataToSubmit));

    try {
      const res = await chanceApi.addComment(dataToSubmit);
      // console.log(res.data);
      if (res.data) {
        setCommentValue('');
        dispatch(listComments(project.prjUuid));
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        mt: 2,
        '& *': { mb: 1 },
      }}
    >
      <CommentForm
        onSubmit={onSubmit}
        commentValue={commentValue}
        handleChange={handleEditorChange}
      />
      {/* <Divider variant="middle" /> */}

      {commentList &&
        commentList.map(
          (comment, index) =>
            !comment?.parentBrdUuid && (
              <div key={index}>
                <SingleComment
                  comment={comment}
                  project={project}
                  commentList={commentList}
                />
              </div>
            ),
        )}
    </Paper>
  );
};

export default CommentList;
